import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

function Row({
  row, actions, active, getControlTP,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        {getControlTP('isCalculate', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('land', row.id, {
          backend: '/api/realty/lands/',
          frontend: '/cat/lands/',
        })}
      </TableCell>
      <TableCell>
        {getControlTP('amount', row.id, { readOnly: true })}
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    amount: PropTypes.number,
    land: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
    isCalculate: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    member: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  errors: PropTypes.shape({ member: PropTypes.arrayOf(PropTypes.string) }),
  getControlTP: PropTypes.func.isRequired,
};

Row.defaultProps = {
  active: false,
  errors: null,
};

export default memo(Row);
